import { createContext, useContext } from 'react';

export type MsTeams = {
    msToken: string | undefined;
};

export const MsTeamsContext = createContext<MsTeams>({} as any);
export const useMsTeams = () => useContext(MsTeamsContext);
